import React from 'react'
import styles from './index.module.scss'

const Spinner = () => {
  return (
    <div className={styles.container}>Loading...</div>
  )
}

export default Spinner